
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/enterprise",
      function () {
        return require("private-next-pages/apipages/enterprise/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/enterprise"])
      });
    }
  